import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { getValueByString } from "../Utils";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  options?: RegisterOptions;

  step?: number;
  tooltipId?: string;
  isDisabled?: boolean;
  min?: number;
  max?: number;
}

const CheckboxEditor = ({ label, fieldName, formHook, options, step, tooltipId, isDisabled, min, max }: IProps) => {
  const { register, formState } = formHook;
  const globalData = useGlobalData();
  const errors = formState.errors;

  const isInValid: any = getValueByString(errors, fieldName);

  options = options || {};
  if (options) {
    if (!options.valueAsNumber && !options.setValueAs) options.valueAsNumber = true;
  }

  const renderTooltip = (props: any) => {
    if (isInValid)
      return (
        <Tooltip {...props} className="validationErrorTooltip">
          <span>{isInValid.message}</span>
        </Tooltip>
      );
    if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</span>
        </Tooltip>
      );
    else return <></>;
  };

  const getCheckboxEditor = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <OverlayTrigger placement="top" overlay={renderTooltip}>
        <div className={"form-check w-100"}>
          {isDisabled ? (
            <input value={""} type="checkbox" disabled={isDisabled} className={"form-check-input"} />
          ) : (
            <input
              id={label}
              type="checkbox"
              min={min}
              max={max}
              step={step}
              disabled={isDisabled}
              {...register(fieldName, options)}
              className={"form-check-input " + (isInValid ? "is-invalid" : "")}
            />
          )}
          {label && (
            <label htmlFor={label} className="form-check-label">
              {label}
            </label>
          )}

          {/* {errors[fieldName]?.message && <div className="invalid-feedback">{errors[fieldName]?.message?.toString()}</div>} */}
        </div>
      </OverlayTrigger>
    );

    //Label if exists
    // if (label) {
    //   htmlPart = (
    //     <label className="form-label w-100">
    //       {label}
    //       {htmlPart}
    //     </label>
    //   );
    // }

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getCheckboxEditor()}</>;
};

export default CheckboxEditor;
